<template>
  <div :class="jel_getClassObject(content)">
    <div
      class="entete d-flex justify-content-between align-items-center mx-n2"
      :class="{ 'entete-sans-titre': !content.titre }"
    >
      <div class="d-flex align-items-center retourLien px-2 py-0">
        <Hyperlien
          :content="{
            texte: content.titre,
            type: 'd-inline-flex lienTertiaire graphik_semibold',
            lien: content.titre
              ? {
                  ...content.lien,
                  nomIcone: 'fleche-droite-mini-lien',
                  positionImage: 'gauche',
                  cssIcone: 'rotation180',
                }
              : { field: 'aucunLien' },
          }"
        >
        </Hyperlien>
      </div>
      <!-- TODO: Bouton recherche à implémenter (hors-portée) -->
      <!-- <b-link href="#" class="p-2"><b-icon icon="search" scale="0.9"></b-icon></b-link> -->
    </div>
    <Menu :content="contentMenu">
      <template #element="{ itemElement }">
        <div class="d-flex flex-row pt-2">
          <b-img-lazy
            v-if="itemElement.image"
            class="mr-2"
            :src="jel_getFichierSrc(itemElement.image)"
          />
          <div
            :class="
              itemElement.lien.field === 'aucunLien'
                ? itemElement['@name'] == 'listeItems0'
                  ? 'graphik_bold body-2 pt-1'
                  : 'graphik_bold body-2 pt-2'
                : itemElement.lien.field === 'body-3'
            "
          >
            {{ itemElement.item }}
          </div>
          <b-icon
            v-if="itemElement.lien.field !== 'aucunLien'"
            scale="0.7"
            icon="chevron-right"
            class="ml-auto mr-0"
          ></b-icon>
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import Menu from '@/components/base/Menu';
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'MenuPage',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Hyperlien, Menu },
  props: { content: { type: Object, required: true } },
  computed: {
    listeItems() {
      const itemsFiltre = [];
      this.content.listeItems['@nodes'].forEach((item) => {
        itemsFiltre.push(this.content.listeItems[item]);
      });
      return itemsFiltre;
    },
    contentMenu() {
      return {
        titre: '',
        listeItems: this.content.listeItems,
        menuCategories: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
div.entete,
svg {
  color: $couleur-bleu-fonce-lq;
}
div.entete {
  background-color: #f9f9f9;
  div::v-deep {
    .lienTertiaire {
      text-decoration: none;
      padding: 1rem 0;
      white-space: nowrap;
    }
    div:first-child .lienTertiaire {
      padding: 0.5rem;
      margin: 0.5rem;
      margin-left: 0;
    }
  }
}
@include media-breakpoint-up(md) {
  div.entete {
    font-size: 1.125rem;
    line-height: 1.375rem;
  }
  div::v-deep div.list-group .list-group-item-categories {
    font-size: 1.125rem;
    &.liste-titre {
      font-size: 1.25rem;
      margin-bottom: 0.5rem;
    }
  }
}
.a {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
}
div.entete-sans-titre {
  padding-top: 56px;
}
div.list-group {
  .list-group-item-categories {
    padding: 0 1rem;
    > div {
      border-bottom: 1px solid #e2e7f0;
      padding-bottom: 1rem;
    }
    svg {
      color: #1928729a;
    }
    &.liste-titre {
      margin-top: 1rem;
      font-family: graphik_black;
      > div {
        border: none;
        padding-bottom: 0.3rem;
      }
      svg {
        display: none;
      }
    }
    &:last-child {
      margin-bottom: 0.5rem;
      border-bottom-width: 1px;
    }
    &:hover {
      background-color: $couleur-fond-primaire;
    }
  }
}
</style>
